export function isLogisticsQuoteValueEmpty(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "number") return !Number.isFinite(value);
  return String(value).trim() === "";
}

const REQUIRED_FIELD_RULES = [
  { key: "currency", label: "Currency" },
  { key: "validityDays", label: "Validity (Days)" },
  { key: "transitDays", label: "Transit Time (Days)" },
  { key: "quoteExpiryDate", label: "Quote Expiry Date" },
  { key: "vesselName", label: "Vessel Name" },
  { key: "voyageNumber", label: "Voyage Number" },
  { key: "estDeparture", label: "Est. Departure" },
  { key: "estArrival", label: "Est. Arrival" },
  { key: "oceanFreight", label: "Ocean Freight" },
  { key: "fuelSurcharge", label: "BAF / Fuel Surcharge" },
  { key: "portHandling", label: "Port Handling" },
  { key: "documentation", label: "Documentation" },
  { key: "containerDeposit", label: "Container Deposit (Refundable)" },
  { key: "loadingCharge", label: "Loading Charges" },
  { key: "unloadingCharge", label: "Unloading Charges" },
  { key: "freeDaysOrigin", label: "Free Days at Origin" },
  { key: "freeDaysDestination", label: "Free Days at Destination" },
  { key: "detentionPerDay", label: "Detention per Day" },
  { key: "demurragePerDay", label: "Demurrage per Day" },
  { key: "paymentTerms", label: "Payment Terms" },
  { key: "exclusions", label: "Exclusions" },
  { key: "generalTerms", label: "General Terms & Conditions" },
  { key: "insuranceAmount", label: "Insurance Amount", when: (form) => Boolean(form.cargoInsuranceOn) },
  { key: "coveragePercent", label: "Coverage %", when: (form) => Boolean(form.cargoInsuranceOn) },
  { key: "coverageType", label: "Coverage Type", when: (form) => Boolean(form.cargoInsuranceOn) },
  {
    key: "customsClearanceCharge",
    label: "Customs Clearance Charges",
    when: (form) => Boolean(form.customsOn),
  },
  { key: "freeDaysIncluded", label: "Free Days Included", when: (form) => Boolean(form.warehousingOn) },
  { key: "baseStorageCharge", label: "Base Storage Charge", when: (form) => Boolean(form.warehousingOn) },
  {
    key: "perDayChargeAfterFree",
    label: "Per Day Charge (After Free Days)",
    when: (form) => Boolean(form.warehousingOn),
  },
  { key: "pickupLocation", label: "Pickup Location", when: (form) => Boolean(form.pickupOn) },
  { key: "pickupCharge", label: "Pickup Charges", when: (form) => Boolean(form.pickupOn) },
  { key: "deliveryLocation", label: "Delivery Location", when: (form) => Boolean(form.deliveryOn) },
  { key: "deliveryCharge", label: "Delivery Charges", when: (form) => Boolean(form.deliveryOn) },
];

/**
 * @param {string} fieldKey
 * @param {Record<string, unknown>} form
 */
export function isLogisticsQuoteFieldRequired(fieldKey, form) {
  return REQUIRED_FIELD_RULES.some((rule) => {
    if (rule.key !== fieldKey) return false;
    if (typeof rule.when === "function") return rule.when(form);
    return true;
  });
}

/**
 * @param {Record<string, unknown>} form
 * @returns {{ valid: boolean, fieldErrors: Record<string, string>, missingLabels: string[] }}
 */
export function validateLogisticsQuoteForm(form) {
  const fieldErrors = {};

  REQUIRED_FIELD_RULES.forEach((rule) => {
    const isRequired = typeof rule.when === "function" ? rule.when(form) : true;
    if (!isRequired) return;
    if (!fieldErrors[rule.key] && isLogisticsQuoteValueEmpty(form[rule.key])) {
      fieldErrors[rule.key] = `${rule.label} is required`;
    }
  });

  const missingLabels = Object.values(fieldErrors);

  return {
    valid: missingLabels.length === 0,
    fieldErrors,
    missingLabels,
  };
}
